import { render, staticRenderFns } from "./WidgetChildReport.vue?vue&type=template&id=2633a3bc&scoped=true&"
import script from "./WidgetChildReport.vue?vue&type=script&lang=js&"
export * from "./WidgetChildReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633a3bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2633a3bc')) {
      api.createRecord('2633a3bc', component.options)
    } else {
      api.reload('2633a3bc', component.options)
    }
    module.hot.accept("./WidgetChildReport.vue?vue&type=template&id=2633a3bc&scoped=true&", function () {
      api.rerender('2633a3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetChildReport.vue"
export default component.exports